<template>
  <div class="indoorEnvironmentMenuList">
    <el-radio-group v-model="active"
      size="small"
      @change="changeBtn">
      <el-radio-button :label="v.key"
        v-for="(v, i) in dataList"
        :key="i"><span class="circular"
          v-if="v.name !== '全部'"
          :style="{
            background:
              v.name == '在线'
                ? '#22AB67'
                : v.name == '离线'
                ? '#777'
                : '#EC5453',
          }"></span>
        {{ v.name }} {{ v.num }}</el-radio-button>
    </el-radio-group>
    <el-input placeholder="请输入内容"
      v-model="searchTxt"
      style="margin-top: 20px"
      clearable>
    </el-input>
    <ul class="scrollUl">
      <template v-if="filterFruitList.length">
        <li v-for="(v, i) in filterFruitList"
          :key="i"
          :class="defaultSelect == v.deviceId ? 'activetItem' : ''"
          onselectstart="return false;"
          @click="defaultSelect = v.deviceId"
          :id="'li' + i">
          <span class="circular"
            :style="{
            background:
              v.status == '在线'
                ? '#22AB67'
                : v.status == '离线'
                ? '#777'
                : '#EC5453',
            marginRight: '10px',
          }"></span>{{ v.name }}
        </li>
      </template>

      <p v-else
        style="text-align:center;margin-top:40px">暂无数据</p>
    </ul>
    <div class="buttons">
      <el-button type="primary"
        style="width: 100%"
        @click="onSubmit">确 认</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      searchTxt: "",
      active: "all",
      dataList: [
        { name: "全部", num: null, key: "all" },
        { name: "在线", num: null, key: "online" },
        { name: "离线", num: null, key: "offline" },
        { name: "告警", num: null, key: "alert" },
      ],
      regionList: [],
      defaultSelect: null,
      allEquipment: {},
    };
  },
  computed: {
    filterFruitList() {
      return this.regionList.filter((item) => {
        return item.name.indexOf(this.searchTxt) !== -1;
      });
    },
  },
  methods: {
    changeClickData(data) {
      this.defaultSelect = data.deviceId;
      let index = this.regionList.findIndex((v) => {
        return v.deviceId == this.defaultSelect;
      });
      let target = document.getElementById("li" + index);
      let parent = document.getElementsByClassName("scrollUl")[0];
      parent.scrollTo(0, target.offsetTop - parent.offsetTop);
    },
    onSubmit() {
      this.regionList = this.handlerState(this.regionList);
      this.$emit("setListData", this.handlerState(this.regionList));
      this.$emit("getClickData", {
        activeItem: this.regionList.find((v) => {
          return v.deviceId == this.defaultSelect;
        }),
        status: this.active,
      });
    },
    handlerState(arr) {
      arr.map((v) => {
        v.state =
          v.status == "在线"
            ? "online"
            : v.status == "离线"
            ? "offline"
            : "alert";
      });
      return arr;
    },
    changeBtn() {
      this.regionList = [];
      this.searchTxt = "";
      document.getElementsByClassName("scrollUl")[0].scrollTop = 0;
      this.regionList = this.allEquipment[this.active];
      this.defaultSelect = this.regionList.length
        ? this.regionList[0].deviceId
        : null;
      this.onSubmit();
    },
    async getEquipmentList() {
      let res = await api.subsystemIndoorData({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        this.allEquipment = res.data.data;
        this.dataList.map((item) => {
          item.num = this.allEquipment[item.key].length;
        });
        this.regionList = this.allEquipment[this.active];
        this.defaultSelect = this.regionList.length
          ? this.regionList[0].deviceId
          : null;
        this.onSubmit();
      }
    },
  },
  created() {
    this.getEquipmentList();
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.$on("handleMapClick", (data) => {
        this.changeClickData(data);
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.indoorEnvironmentMenuList {
  width: 93%;
  height: 94%;
  margin: 20px auto;
  .circular {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
  }
  ul {
    height: 75%;
    background: #f7f7f7;
    border: 1px solid #e7e7e7;
    border-radius: 6px;
    margin: 20px 0;
    overflow: auto;
    li {
      width: 90%;
      text-indent: 15px;
      line-height: 30px;
      margin: 10px auto;
      cursor: default;
    }
    li:hover {
      background: rgba(40, 204, 203, 0.5);
      color: #fff;
    }
    .activetItem {
      background: #28cccb !important;
      color: #fff;
    }
  }
  .buttons {
    width: 55%;
    margin: 0 auto;
  }
}
</style>